import { render, staticRenderFns } from "./editCategory.vue?vue&type=template&id=46b454e8&"
import script from "./editCategory.vue?vue&type=script&lang=js&"
export * from "./editCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports